import React from "react";
import Form from "./Form";
import { useFormik } from "formik";
import { create } from "ducks/filters";
import { add } from "ducks/toasts";

import { connect } from "react-redux";
import { useRemoveQueryNavigation } from "helpers/hooks/url";
const CreateFilter = ({ add, create }) => {
  const onClose = useRemoveQueryNavigation("createFilter");
  const { values, handleSubmit, setFieldValue } = useFormik({
    enableReinitialize: true,
    initialValues: { label: "", active: true, fields: [] },
    onSubmit: values => {
      create(values);
      add(
        "Update erfolgreich",
        "Benutzer wurde erfolgreich aktualisiert",
        "success",
        "user"
      );
    }
  });

  return values ? (
    <Form
      subtitle="Neuen Filter erstellen"
      values={values}
      handleChange={setFieldValue}
      handleSubmit={handleSubmit}
      handleClose={onClose}
    ></Form>
  ) : (
    false
  );
};

export default connect(null, { create, add })(CreateFilter);
